import React, { useState } from 'react';
import { withJsonFormsControlProps } from '@jsonforms/react';
import { rankWith, scopeEndsWith } from '@jsonforms/core';
import { Box, Stack, InputLabel, MenuItem, FormControl, Select, FormControlLabel, Checkbox } from '@mui/material';


function SkillsRangeField(props) {
  const { id, label, handleChange, path, schema } = props;


  const handleChangeSelectValue = (value, key) => {
    console.log(key);
    const data = props.data ?? [];
    const newData = data.filter(item => item !== key).filter(item => item !== `${key} trenuje`)
      .filter(item => item !== `${key} kurs/certyfikat`);

    if (value !== 'nil') {
      newData.push(value);
    }

    handleChange(path, newData);
  };

  const getCurrentSelectValue = key => {
    if (props.data) {
      if (props.data.includes(`${key}`)) {
        return `${key}`;
      } else if (props.data.includes(`${key} trenuje`)) {
        return `${key} trenuje`;
      } else if (props.data.includes(`${key} kurs/certyfikat`)) {
        return `${key} kurs/certyfikat`;
      }
    }

    return 'nil';
  };

  return (
    <fieldset id={id} style={{ border: 'none', marginBottom: '20px' }}>
      <Stack sx={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: '32px' }}>
        {schema.items.oneOf.map((item, idx) => <FormControl sx={{ width: '300px' }} key={idx} variant="standard">
          <InputLabel id={`${idx}-${item.title}`} sx={{ fontSize: '21px' }}>{item.title}</InputLabel>
          <Select
            labelId={`${idx}-${item.title}`}
            label={item.title}
            value={getCurrentSelectValue(item.const)}
            onChange={event => handleChangeSelectValue(event.target.value, item.const)}
          >
            <MenuItem value="nil">
              Nie dotyczy
            </MenuItem>
            <MenuItem value={`${item.const}`}>Hobby</MenuItem>
            <MenuItem value={`${item.const} trenuje`}>Trenuję</MenuItem>
            <MenuItem value={`${item.const} kurs/certyfikat`}>Posiadam certyfikat/przeszedłem kurs</MenuItem>
          </Select>
        </FormControl>)}
        <FormControlLabel control={<Checkbox checked={props.data?.includes('inne')} onChange={event => {
          const data = props.data ?? [];
          const newData = data.filter(item => item !== 'inne');
          if (event.target.checked) {
            newData.push('inne');
          }
          handleChange(path, newData);
        }} />} label="Inne" />
      </Stack>
    </fieldset>
  );
}

export default withJsonFormsControlProps(SkillsRangeField);

export const SkillsRangeFieldTester = rankWith(
  1000,
  scopeEndsWith('rangeOfSkills')
);
